import { action, observable, computed } from 'mobx';
import { Config } from '~domain/entities/Config';
import { FindInStore } from '~domain/entities/FindInStore';
import { StoresRepository } from '~repositories/StoresRepository';
import { FindInStoreButtonLoadedUseCase } from '~use-cases/FindInStoreButtonLoadedUseCase';
import { ServiceViewWithModalViewController } from './ServiceViewWithModalViewController';

export class FindInStoreViewController extends ServiceViewWithModalViewController {
    @observable public config: Config;
    @observable public findInStore: FindInStore;

    constructor(config: Config, findInStore: FindInStore, storeRepository: StoresRepository) {
        super();
        this.config = config;
        this.findInStore = findInStore;
        this.storeRepository = storeRepository;
    }

    @action
    public buttonLoaded = (skuId: string) => {
        new FindInStoreButtonLoadedUseCase(skuId).execute();
    };

    @action
    public onCloseStoreLocatorFISOverlay = () => {
        this.onCloseStoreLocatorOverlay();
        this.storeRepository.storeInventory = {};
    };

    @computed
    public get data() {
        return {
            isFisEnabled: this.config.config.fis.enable,
            findInStore: this.findInStore,
            isServiceLocatorOverlayVisible: this.isServiceLocatorOverlayVisible
        };
    }
}
